export const USER_ANNOUNCEMENT_SEEN_MAP = 'seenAnnouncements';
